import { StatusPill } from '@ui-kit';
import type { StatusTone } from '@ui-kit';

interface BackendBadgeProps {
  backend: string;
}

function backendTone(backend: string): StatusTone {
  if (backend === 's3') return 'info';
  if (backend === 'sftp') return 'warning';
  return 'neutral';
}

/**
 * BackendBadge — 현재 FileManager backend (local/s3/sftp) 를 색상 Pill 로 표시
 */
export function BackendBadge({ backend }: BackendBadgeProps) {
  return (
    <StatusPill tone={backendTone(backend)}>
      {backend.toUpperCase()}
    </StatusPill>
  );
}
